import { useMemo } from "react";
//#region redux
//#endregion
//#region types
import { AutomationRuleEnums } from "models/enums";
import { AutomationRuleFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
import {
  useCreateReceiptDraftFormHelpers,
  useReceiptDraftFormValidation,
} from "components/automationRule/forms/receiptDraft";
//#region  components
//#endregion
import * as Yup from "yup";

function useCreateFormHelpers() {
  const { receiptDraftValidationScheme } = useReceiptDraftFormValidation();
  const { wintCardPaymentMenthods } = useCreateReceiptDraftFormHelpers();

  const initialCreateValues = useMemo<AutomationRuleFormTypes.AutomationRuleCreate>(() => {
    return {
      type: AutomationRuleEnums.AutomationRuleType.ReceiptDraft,
      receiptDraft: {
        paymentMethodId:
          wintCardPaymentMenthods.length === 1 ? (wintCardPaymentMenthods[0].value as number) : undefined,
        isActive: true,
      },
    };
  }, [wintCardPaymentMenthods]);

  const validationScheme = useMemo(
    () =>
      Yup.object<AutomationRuleFormTypes.AutomationRuleCreate>({
        type: Yup.number().required(TranslationKeys.Validations.Required),
        receiptDraft: receiptDraftValidationScheme,
      }),
    []
  );

  return {
    initialCreateValues,
    validationScheme,
  };
}

export default useCreateFormHelpers;
